import React, { useState, useEffect } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import CustomBreadcrumb from "../components/CustomBreadcrumb";
import PageTitle from "../components/PageTitle";
import CardWrapper from "../layouts/CardWrapper";
import { Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { Document, Page, Text, PDFDownloadLink, pdf, PDFViewer } from "@react-pdf/renderer";
import ReportPDF from "./ReportPreview/ReportPDF";
import Col from "react-bootstrap/Col";
import { useDebounce } from "../hooks/useDebounce"; // adjust path as needed
import Dropdown from "react-bootstrap/Dropdown";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import TablePagination from "../components/TablePagination/TablePagination";
import { Link, useNavigate } from "react-router-dom";
import {
  EditIcon,
  TrashIcon,
  PlusIcon,
  SharedIcon,
  ArrowsClockwiseIcon,
  ArrowSquareOutIcon,
} from "../components/SVGIcon";
import { useAtom } from 'jotai';
import { authAtom } from "../states/auth";
import { getReports, deleteReportById,shareReportById, transferReportById } from "../services/reportService";
import ReportPreview from "./ReportPreview/ReportPreview";
import { useAlert } from "../contexts/AlertContext";
import ExpertAssignList from "../components/DetailsPanel/ExpertAssignList";
import { listExpertUsers } from "../services/userService";

const options = {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true // Use 12-hour clock with AM/PM
};

const toUTCStartOfDay = (date) => {
  if (!date) return null;
  // Take local midnight (IST), then convert to UTC
  const start = new Date(date);
  start.setHours(0, 0, 0, 0);
  return start.toISOString();
};

const toUTCEndOfDay = (date) => {
  if (!date) return null;
  // Take local 23:59:59.999 (IST), then convert to UTC
  const end = new Date(date);
  end.setHours(23, 59, 59, 999);
  return end.toISOString();
};

const getThisMonthRange = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1);
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  return { from: start, to: end };
};

const ReportHubExpert = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const initialRange = getThisMonthRange();
  const [range, setRange] = useState(initialRange);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showOptOutModal, setShowOptOutModal] = useState(false);
  const [showShareReportModal, setShowShareReportModal] = useState(false);
  const [totalReportsCount, setTotalReportsCount] = useState(null);
  const { showAlert } = useAlert();
  const [auth] = useAtom(authAtom);
  const [reportsShow, setReportsShow] = useState([]);
  const [expertUsers, setExpertUsers] = useState([]);
  const [shareReportList, setShareReportList] = useState({userIDs:[], emails:[]});
  const [shareReportListForApi, setShareReportListForApi] = useState({userIDs:[], emails:[]});
  const [emailInput, setEmailInput] = useState("");
  const [transferReportListUser, setTransferReportListUser] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sharedReportCounter, setSharedReportCounter] = useState(null);
  const [transferReportCounter, setTransferReportCounter] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [showReportInfo, setShowReportInfo] = useState(false);
  const [shareReport, setShareReport] = useState(false);
  const [tranferReport, setTranferReport] = useState(false);
  const [reportFilter, setReportFilter] = useState(null);
  const [reportToPreview, setReportToPreview] = useState(null);
  const [reportsToDelete, setReportsToDelete] = useState(null);
  const [sharedWithCurrentUser, setSharedWithCurrentUser] = useState(null);
  const [transferReportModal, setTransferReportModal] = useState(false);
  const [shareReportByContact, setShareReportByContact] = useState(true);
  const [shareReportByEmail, setShareReportByEmail] = useState(false);
  const [activeReport, setActiveReport] = useState(null);
  const navigate = useNavigate();
  const [selectedPage, setSelectedPage] = useState(1);
  const [sidebarCollapsedByReport, setSidebarCollapsedByReport] = useState(false);

  const setShareReportListHandle = (name, list) => {
  // Update field first
  shareReportList[name] = list;

  // Transform userIDs -> array of IDs
  const transformedUserIDs = Array.isArray(shareReportList.userIDs)
    ? shareReportList.userIDs.map(item =>
        typeof item === "string" ? item : item.id
      )
    : [];

  // Transform emails -> array of strings
  const transformedEmails = Array.isArray(shareReportList.emails)
    ? shareReportList.emails.map(item =>
        typeof item === "string" ? item : item.email
      )
    : [];

  // Construct final object
  const updatedShareReportList = {
    userIDs: transformedUserIDs,
    emails: transformedEmails,
  };

  console.log("Updated shareReportList =", updatedShareReportList);

  // Set state
  setShareReportListForApi({...updatedShareReportList});
};

  const [reportFilterParam, setReportFilterParam] = useState({
    no_of_result: 12,
    page: 1,
    search: null,
    endDate:null,
    startDate: null,
    filter: "all",
  });


  const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);

const addEmailsFromInput = () => {
  if (!emailInput) return;

  const raw = emailInput.split(",").map(e => e.trim()).filter(Boolean);
  const invalid = raw.filter(e => !isValidEmail(e));

  if (invalid.length) {
    showAlert({
      title: "Invalid Email",
      message: `Invalid email(s): ${invalid.join(", ")}`,
      variant: "danger",
    });
    return;
  }

  const merged = [...shareReportList.userIDs, ...raw];
  const unique = Array.from(new Set(merged));

  setShareReportList({ userIDs: unique });
  setEmailInput("");
};

  const downloadFile = async () => {

    const blob = await pdf(<ReportPDF data={activeReport} />).toBlob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "example.pdf";
    link.click();

  }

const removeEmail = (emailToRemove) => {
  const updated = shareReportList.userIDs.filter(e => e !== emailToRemove);
  setShareReportList({ userIDs: updated });
};


  const debouncedFilter = useDebounce(reportFilterParam, 500);

  const changeFilterCriteria = (e) => {
    if (e.target.name == "search") {
      reportFilterParam.page = 1;
      setSelectedPage(1);
    }
    console.log(e.target.name, e.target.value);
    reportFilterParam[e.target.name] = e.target.value;
    setReportFilterParam({ ...reportFilterParam });
    console.log("filter", reportFilterParam);
  };


  const handleCheckboxChange = (templateId) => {
    setSelectedFiles((prev) =>
      prev.includes(templateId)
        ? prev.filter((id) => id !== templateId)
        : [...prev, templateId]
    );

    console.log(
      "selectChange",
      selectedFiles.includes(templateId)
        ? selectedFiles.filter((id) => id !== templateId)
        : [...selectedFiles, templateId]
    );
  };

  const changeFilterCriteriaByName = (name, value) => {
    console.log(name, value);
    reportFilterParam[name] = value;
    setReportFilterParam({ ...reportFilterParam });
    console.log("filter", reportFilterParam);
  };

  useEffect(() => {
    changeFilterCriteriaByName("page", selectedPage);
  }, [selectedPage]);

  useEffect(() => {
    listExpertUsers({ userTypeFilter: 1 }).then((response) =>{
      setExpertUsers(response?.data);
      console.log("allexperts",response?.data)
    });
  }, []);

  const handleTransportReportAPI = async() => {
    console.log(activeReport?.id);
    console.log(transferReportListUser);
    // setTransferReportModal(true)
    try {
      // Delete single template
      const response = await transferReportById(activeReport?.id, transferReportListUser[0]?.id);
      setTransferReportModal(true);
      showAlert({
        title: "Report Notification",
        message: "Report shared successfully.",
        variant: "success",
      });
    } catch (err) {
      console.error("Error deleting template:", err);
      showAlert({
        title: "Report Notification",
        message: err?.response?.data?.message ?? "Something went wrong",
        variant: "danger",
      });
    }
  }

  const handleCallShareReportAPI = async() => {
    // Transform userIDs -> array of IDs
  const transformedUserIDs = Array.isArray(shareReportList.userIDs)
    ? shareReportList.userIDs.map(item =>
        typeof item === "string" ? item : item.id
      )
    : [];

  // Transform emails -> array of strings
  const transformedEmails = Array.isArray(shareReportList.emails)
    ? shareReportList.emails.map(item =>
        typeof item === "string" ? item : item.email
      )
    : [];

  // Construct final object
  const updatedShareReportList = {
    userIDs: transformedUserIDs,
    emails: transformedEmails,
  };

    console.log("asdasdasd", shareReportList, shareReportListForApi, updatedShareReportList)
    try {
      // Delete single template
      const response = await shareReportById(activeReport?.id, updatedShareReportList);
      setShowShareReportModal(true)
      showAlert({
        title: "Report Notification",
        message: "Report shared successfully.",
        variant: "success",
      });
    } catch (err) {
      console.error("Error deleting template:", err);
      showAlert({
        title: "Report Notification",
        message: err?.response?.data?.message ?? "Something went wrong",
        variant: "danger",
      });
    }
    
  }

  const handleSelectAllTemplates = () => {
    if (selectedFiles.length === reportsShow.length) {
      setSelectedFiles([]);
    } else {
      const filesToDownload = reportsShow?.map((e) => e.id);
      setSelectedFiles(filesToDownload);
    }
  };

  const changeTemplateFilterCriteriaByName = (name, value) => {
    setReportFilterParam((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const mapShareReportListFromResponse = (reportData) => {
  if (!reportData) return { userIDs: [], emails: [] };

  // 1️⃣ Map sharedReports → array of user objects
  const userIDs = Array.isArray(reportData.sharedReports)
    ? reportData.sharedReports
        .filter(item => item?.user?.id) // ensure valid
        .map(item => ({
          id: item.user.id,
          firstName: item.user.firstName || item.sharedBy?.firstName || "",
          lastName: item.user.lastName || item.sharedBy?.lastName || "",
          profilePic: item.user.profilePic || "",
        }))
    : [];

  // 2️⃣ Map emailSharedReports → array of email strings
  const emails = Array.isArray(reportData.emailSharedReports)
    ? reportData.emailSharedReports
        .filter(item => item?.email) // ensure email exists
        .map(item => item.email)
    : [];

  return { userIDs, emails };
};


  useEffect(() => {
    if(activeReport != null){
      const prepopulatedList = mapShareReportListFromResponse(activeReport);
      console.log("prepopulatedList",prepopulatedList)
      const sharedWithCurrentUserdata  = activeReport?.sharedReports?.find(
        (report) => report?.user?.id === auth?.user?.id
      );
      setSharedWithCurrentUser(sharedWithCurrentUserdata)
      setShareReportList(prepopulatedList);
    }
  }, [activeReport]);

  console.log("sharedWithCurrentUser", sharedWithCurrentUser)

  useEffect(() => {
    // if (range?.from || range?.to) {
    setReportsShow(null);
    setReportFilterParam((prev) => ({
      ...prev,
      startDate: toUTCStartOfDay(range?.from),
      endDate: toUTCEndOfDay(range?.to),
    }));

    // }
    console.log("filterAaA", reportFilterParam);
  }, [range]);

  const reportFilterHandler = (type) => {
    setReportFilter(type);
  };

  const deleteSelected = async (data) => {
      try {
        // Delete single template
        const response = await deleteReportById(data);

        showAlert({
          title: "Report Notification",
          message: "Report deleted successfully.",
          variant: "success",
        });
      } catch (err) {
        console.error("Error deleting template:", err);
        showAlert({
          title: "Report Notification",
          message: err?.response?.data?.message ?? "Something went wrong",
          variant: "danger",
        });
      }
      setShowDeleteModal(false);
      getAllTemplates();
      setReportsToDelete(null);
      if(data?.includes(activeReport?.id)){
        setActiveReport(null);
      }
      setSelectedFiles([]);
  };

  const getAllTemplates = async () => {
    setLoading(true);
    try {
      const query = { ...debouncedFilter };
      // remove templateType if "all"
      // if (query.filter === "all") {
      //   delete query.filter;
      // }
      const data = await getReports(query);

      const tempplateFiles = data?.data || [];

      let transferReportCounterConst = 0;
      let sharedReportCounterConst = 0;
      const createdFiles = tempplateFiles.map((element) => {
        let badge = null;
        if (element.templateType === "field") {
          badge = { text: "Field", className: "badge-success" };
        } else {
          badge = { text: "Digital", className: "badge-primary" };
        }
        if(element?.sharedReports?.length > 0){
          sharedReportCounterConst+=1;
        }
        if(element?.owner?.id ===  auth?.user?.id){
          transferReportCounterConst+=1;
        }
        // if(element.createdBy.id != auth?.user?.id && element.transferReportsLogs.length > 0){
          
        //   element?.transferReportsLogs?.find(e)

        // }
        return {
          ...element,
          img: "/images/file-type-icon-pdf.svg",
          badge,
          author: (element?.createdBy?.firstName ?? "") +' '+ (element?.createdBy?.lastName ?? ""),
        };
      });
      setSharedReportCounter(sharedReportCounterConst);
      setTransferReportCounter(transferReportCounterConst);
      console.log("sharedReportCounterConst,",sharedReportCounterConst);
      console.log("transferReportCounterConst,",transferReportCounterConst);
      console.log("filessss", createdFiles);
      setSelectedFiles([]);
      setTotalReportsCount(data?.totalResult);
      setReportsShow(createdFiles || []); // adjust based on API response shape
    } catch (err) {
      console.error("Error fetching templates:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllTemplates();
  }, [debouncedFilter]); // re-fetch when filters change
  // Sample data for 8 templates

  const formatDate = (date) => {
    if (!date) return "From - To Date";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    return `${month}-${day}-${year}`;
  };
  const BeadcrumbItems = [{ label: "Report Hub", active: true }];


  return (
    <>
      <Row className="align-items-end justify-content-between mb-4">
        <Col lg="7">
          <CustomBreadcrumb items={BeadcrumbItems} />
          <PageTitle title="Report Hub" />
        </Col>
        <Col lg="5" className="text-end">
          <Dropdown>
            <Dropdown.Toggle
              variant="blue"
              className="btn btn-md dropdown-toggle d-inline-flex align-items-center justify-content-end gap-1"
              align="end"
            >
              Create New Report
            </Dropdown.Toggle>

            <Dropdown.Menu className="template-dropdown-menu dropdown-menu-end">
              <Row className="gx-2">
                <Col md="6">
                  <Link
                    to={`/report-hub/create/digital`}
                    className="template-dropdown-item bg-blue-100"
                  >
                    <div className="template-dropdown-icon rounded-pill bg-white text-blue-600">
                      <PlusIcon />
                    </div>
                    <p className="fs-14 fw-500 text-gray-700 mt-2 mb-0">
                      Create Session
                      <br /> Report
                    </p>
                  </Link>
                </Col>
                <Col md="6">
                  <Link
                    to={`/report-hub/create/field`}
                    className="template-dropdown-item bg-green-100"
                  >
                    <div className="template-dropdown-icon rounded-pill bg-white text-green-600">
                      <PlusIcon />
                    </div>
                    <p className="fs-14 fw-500 text-gray-700 mt-2 mb-0">
                      Create Field
                      <br /> Report
                    </p>
                  </Link>
                </Col>
              </Row>
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
      <Row>
        <Col md={showReportInfo || shareReport || tranferReport ? "9" : "12"}>
          <CardWrapper>
            <Row>
              <Col md="9">
                <div className="btn-tabs">
                  <Button
                    as="button"
                    variant=""
                    className={`btn-md ${
                      reportFilterParam.filter == "all" ? "active" : ""
                    }`}
                    onClick={() => changeFilterCriteriaByName("filter","all")}
                  >
                    All Reports
                  </Button>
                  <Button as="button" variant=""  className={`btn-md ${
                      reportFilterParam.filter == "digital" ? "active" : ""
                    }`}
                    onClick={() => changeFilterCriteriaByName("filter","digital")}
                    >
                    Session
                  </Button>
                  <Button as="button" variant="" className={`btn-md ${
                      reportFilterParam.filter == "field" ? "active" : ""
                    }`}
                  onClick={() => changeFilterCriteriaByName("filter","field")}
                  >
                    Field
                  </Button>
                  <Button
                    as="button"
                    variant=""
                    className={`d-flex align-items-center gap-2 ${
                      reportFilterParam.filter == "shared" ? "active" : ""
                    }`}
                    onClick={() => changeFilterCriteriaByName("filter","shared")}
                  >
                    Shared
                    {(sharedReportCounter > 0) && <span className="number-count">{sharedReportCounter}</span>}
                  </Button>
                  <Button
                    as="button"
                    variant=""
                    className={`d-flex align-items-center gap-2 ${
                      reportFilterParam.filter == "transferred" ? "active" : ""
                    }`}
                    onClick={() => changeFilterCriteriaByName("filter","transferred")}
                  >
                    Transferred
                    {(transferReportCounter>0) && <span className="number-count">{transferReportCounter}</span>}
                  </Button>
                </div>
              </Col>
              <Col md="3">
                <input
                  className="form-control form-control-search"
                  aria-label="Search Input"
                  onChange={(e) => changeFilterCriteriaByName("search",e.target.value)}
                  placeholder="Search here..."
                  type="text"
                />
              </Col>
            </Row>
          </CardWrapper>
          <CardWrapper className="full-box-1 mt-3">
            <Row className="align-items-center mb-4">
              <Col md="3">
                <h2 className="fs-20 fw-600 mb-0">Total Report ({totalReportsCount ?? 0})</h2>
              </Col>
              <Col md="9">
                <Row className="align-items-center justify-content-md-end gy-3 gy-lg-0">
                  <Col className="col-md-4">
                    <Dropdown align="end">
                      <Dropdown.Toggle
                        as="button"
                        id="to-date"
                        className="filter-dropdown-button form-control dropdown-toggle-calendar dropdown-toggle-none d-flex align-items-center justify-content-between gap-2 w-100"
                      >
                        {range?.from && range?.to
                          ? `${formatDate(range?.from)} - ${formatDate(
                              range?.to
                            )}`
                          : "From - To Date"}

                        <Image
                          src="/images/calendar-dots.svg"
                          alt="Calendar Check Icon"
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="calendar-dropdown-menu dropdown-menu dropdown-menu-end">
                        <DayPicker
                          mode="range"
                          selected={range}
                          onSelect={setRange}
                        />
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                </Row>
                
              </Col>
            </Row>
            {selectedFiles?.length > 0 && (
              <div className="bg-blue-100 p-3 rounded-3 d-md-flex align-items-md-center justify-content-md-between mb-4">
                <div className="d-flex align-items-center gap-3 mb-3 mb-md-0">
                  <Button
                    as="button"
                    variant="white"
                    className="btn-md border-0 shadow-none text-blue"
                    onClick={handleSelectAllTemplates}
                  >
                    {selectedFiles.length === reportsShow.length
                      ? "Deselect All"
                      : "Select All"}
                  </Button>
                  <p className="fs-18 fw-semibold mb-0">
                    {selectedFiles?.length}{" "}
                    {selectedFiles.length > 1 ? "items" : "item"} selected
                  </p>
                </div>

                {reportFilter === "template" ? (
                  <Button
                    as="button"
                    variant="white"
                    className="btn-md border-0 shadow-none text-danger d-flex align-items-center gap-1"
                    onClick={() => {
                      setShowDeleteModal(true);
                    }}
                  >
                    <TrashIcon />
                    Delete Selected
                  </Button>
                ) : (
                  <>
                  <Button
                    as="button"
                    variant="white"
                    className="btn-md border-0 shadow-none text-danger d-flex align-items-center gap-1"
                    onClick={() => {
                      setReportsToDelete(selectedFiles.map((e) => e));
                      setShowDeleteModal(true);
                    }}
                  >
                    <TrashIcon />
                    Delete Selected
                  </Button>
                  <Button
                    as="button"
                    variant="primary"
                    className="btn-md d-flex align-items-center gap-1"
                  >
                    <Image
                      src="/images/download-white.svg"
                      width={18}
                      height={18}
                      alt="Download White Icon"
                    />
                    Download Selected
                  </Button>
                  </>
                )}
              </div>
            )}

            <Row className="g-3">
              {reportsShow?.map((report) => {
                const isChecked = selectedFiles.some(
                  (element) => element === report.id
                );
                return <Col xxl="3" lg="4" md="6" key={report.id}>
                  {/* active: class when item is select */}
                  <div
                    className={`file-info-box cursor-pointer ${
                      activeReport === report.id ? "active" : ""
                    }`}
                    onClick={(e) => {
                      setShowReportInfo(true);
                      setActiveReport(report);
                      // Check if sidebar is already collapsed
                      const wasAlreadyCollapsed = document.body.classList.contains("sidebar-collapsed");
                      if (!wasAlreadyCollapsed) {
                        document.body.classList.add("sidebar-collapsed");
                        setSidebarCollapsedByReport(true);
                      } else {
                        setSidebarCollapsedByReport(false);
                      }
                    }}
                  >
                    <div className="file-info-box-body">
                      <div className="d-flex align-items-start justify-content-between gap-2">
                        <Image
                          className="rounded-3 object-fit-cover"
                          src={report.img}
                          width={64}
                          height={64}
                          alt="PDF File"
                        />
                        <div className="d-flex align-items-start gap-2">
                          <div className="d-flex align-items-center gap-2">
                            {(report.sharedReports.length > 0) && (
                              <SharedIcon
                                size={28}
                                className={(report?.createdBy?.id === auth?.user?.id)?"text-yellow-600":"text-gray-600"}
                              />
                            )}
                            {(report?.createdBy?.id != auth?.user?.id && report?.transferReportsLogs?.length > 0) && (
                              <ArrowsClockwiseIcon
                                size={28}
                                className="text-yellow-600"
                              />
                            )}
                            <span className={`badge ${report.badge.className}`}>
                              {report.badge.text}
                            </span>
                          </div>
                          <label
                            className="form-check-label align-items-center"
                            htmlFor={report.id}
                          >
                            <input
                              className="form-check-input"
                              id={report.id}
                              type="checkbox"
                              checked={isChecked}
                              onChange={(e) => (
                                e.stopPropagation(),
                                handleCheckboxChange(report?.id)
                              )}
                            />
                          </label>
                        </div>
                      </div>
                      <h3 className="text-truncate fs-14 fw-medium text-gray-700 mb-0 mt-3">
                        {report.name}
                      </h3>
                      <ul className="d-md-flex align-items-md-center gap-2 list-unstyled mt-2 mb-0">
                        {(report?.createdBy?.id != auth?.user?.id && report?.transferReportsLogs?.length > 0) && <li className="fs-12 fw-medium text-gray-500">
                          Transfered on {formatDate(new Date(report?.transferReportsLogs[report?.transferReportsLogs?.length - 1]?.createdAt))}
                        </li> || ( (report?.sharedReports?.length > 0) && <li className="fs-12 fw-medium text-gray-500">
                          shared on {formatDate(new Date(report.createdAt))}
                        </li> )  || ( (report.createdAt != report.updatedAt && report.updatedAt && report.updatedAt != ""  ) && <li className="fs-12 fw-medium text-gray-500">
                          Updated on {formatDate(new Date(report.updatedAt))}
                        </li> )  || <li className="fs-12 fw-medium text-gray-500">
                          Created on {formatDate(new Date(report.createdAt))}
                        </li>}
                        
                        <li className="dot-separator"></li>
                        {(report?.createdBy?.id != auth?.user?.id && report?.transferReportsLogs?.length > 0) && 
                        <li className="fs-12 fw-medium text-gray-500">
                          Transfered by {report?.transferReportsLogs[report?.transferReportsLogs?.length - 1]?.transferBy?.firstName} {report?.transferReportsLogs[report?.transferReportsLogs?.length - 1]?.transferBy?.lastName}
                        </li>
                        ||
                        <li className="fs-12 fw-medium text-gray-500">
                          {report.author}
                        </li>
                        }
                      </ul>
                    </div>
                  </div>
                </Col>
              })}
            </Row>
            <TablePagination
                  selectedPage={selectedPage}
                  setSelectedPage={setSelectedPage}
                  totalResults={totalReportsCount}
                  resultsPerPage={12}
                />
          </CardWrapper>
        </Col>
        {showReportInfo && (
          <Col md="3">
            <CardWrapper className="d-flex flex-column justify-content-between p-0 full-box-0">
              <div>
                <div className="p-3 border-bottom border-grey-200 d-flex align-items-center justify-content-between gap-3">
                  <h2 className="h5 fw-semibold mb-0">Report Information</h2>
                  <button
                    type="button"
                    className="btn-reset"
                    onClick={() => {
                      setShowReportInfo(false);
                      setActiveReport(null);
                      // Only remove the class if we added it
                      if (sidebarCollapsedByReport) {
                        document.body.classList.remove("sidebar-collapsed");
                        setSidebarCollapsedByReport(false);
                      }
                    }}
                  >
                    <Image src="/images/btn-close-square.svg" />
                  </button>
                </div>
                <div className="p-3 report-info-body">
                  <Image
                    src="/images/file-type-icon-pdf.svg"
                    width={72}
                    height={72}
                    alt="PDF Icon"
                  />
                  <div className="d-flex align-items-center gap-2 my-4">
                    <p className="fs-20 fw-semibold text-gray-700 mb-0">
                      {activeReport?.name}
                    </p>
                  </div>

                  <div className="border-top border-grey-200 py-3">
                    <p className="text-gray-400 fw-400 mb-1">Created By</p>
                    <p className="fs-16 text-gray-700 fw-400 mb-0">
                    {activeReport?.createdBy?.firstName || ""} {activeReport?.createdBy?.lastName || ""}
                    </p>

                    <br />
                    <p className="text-gray-400 fw-400 mb-1">Creation Date</p>
                    <p className="fs-16 text-gray-700 fw-400 mb-0">
                      {new Date(activeReport?.createdAt).toLocaleDateString('en-GB')}
                    </p>

                    {(activeReport?.createdAt != activeReport?.updatedAt && activeReport?.updatedAt && activeReport?.updatedAt != "") && <div className="py-3">
                    <p className="text-gray-400 fw-400 mb-1">Modification Date</p>
                    <p className="fs-16 text-gray-700 fw-400 mb-0">
                      {new Date(activeReport?.updatedAt).toLocaleDateString('en-GB')}
                    </p>
                  </div>}

                  </div>

                  

                  {(activeReport?.sharedReports?.length > 0) && (activeReport?.createdBy?.id != auth?.user?.id) && <div className="border-top border-grey-200 py-3">
                    {(activeReport?.sharedReports?.length > 0) && (activeReport?.createdBy?.id != auth?.user?.id) && <><p className="text-gray-400 fw-400 mb-1">Modified By</p>
                    <p className="fs-16 text-gray-700 fw-400 mb-0">
                    {activeReport?.updatedBy?.firstName || activeReport?.createdBy?.firstName || ""} {activeReport?.updatedBy?.lastName || activeReport?.createdBy?.lastName || ""}
                    </p></>}
                    <br />
                    {(activeReport?.sharedReports?.length > 0) && (activeReport?.createdBy?.id != auth?.user?.id) && <><p className="text-gray-400 fw-400 mb-1">
                      Modification Date
                    </p>
                    <p className="fs-16 text-gray-700 fw-400 mb-0">
                    {new Date(activeReport?.updatedAt).toLocaleDateString('en-GB')}
                    </p></>}
                    {(activeReport?.sharedReports?.length > 0) && (activeReport?.createdBy?.id != auth?.user?.id) && <>
                      <br />
                    {sharedWithCurrentUser?.createdAt && <><p className="text-gray-400 fw-400 mb-1">Shared Date</p>
                    <p className="fs-16 text-gray-700 fw-400 mb-0">
                      {/* "SHOW DATE HERE" */}
                      {new Date(sharedWithCurrentUser?.createdAt).toLocaleDateString('en-GB')}
                    </p></>}</>}
                  </div>}

                  <div className="border-top border-grey-200 py-3">
                    <Button variant="primary" className="w-100" onClick={() => downloadFile()}>
                      Download Report
                    </Button>
                    <Button variant="outline-secondary" className="w-100 mt-2" onClick={() => (setShowPreviewModal(true), setReportToPreview(activeReport))} >
                      Preview Report
                    </Button>
                  </div>
                </div>
              </div>
              <div className="border-top border-grey-200 p-2">
                {((!activeReport?.owner && activeReport?.createdBy?.id !== auth?.user?.id) ||
  (activeReport?.owner && activeReport?.owner?.id !== auth?.user?.id)) && (
                  <Button
                    variant="danger-100"
                    className="btn-md d-flex align-items-center justify-content-center gap-2 w-100"
                    onClick={() => setShowOptOutModal(true)}
                  >
                    <ArrowSquareOutIcon size={20} />
                    Opt-Out
                  </Button>
                )}
                {((activeReport?.createdBy?.id == auth?.user?.id) || (activeReport?.owner?.id == auth?.user?.id))  && (
                  <Row className="g-2">
                    <Col sm="6">
                      <Button
                        variant="primary-100"
                        className="btn-md d-flex align-items-center justify-content-center gap-2 w-100"
                        onClick={()=>navigate(`/report-hub/edit/${activeReport?.id}`)}
                      >
                        <EditIcon size={20} />
                        Edit
                      </Button>
                    </Col>
                    <Col sm="6">
                    
                      <Button
                        variant="primary-100"
                        className="btn-md d-flex align-items-center justify-content-center gap-2 w-100"
                        onClick={() => {
                          setShareReport(true);
                          setShowReportInfo(false);
                        }}
                      >
                        <SharedIcon size={20} />
                        {(activeReport?.sharedReports?.length == 0)?"Share":"Manage Sharing"}
                      </Button>
              
                      
                    </Col>
                    {/* <Col sm="6">
                    <Button
                      variant="primary-100"
                      className="btn-md d-flex align-items-center justify-content-center gap-2 w-100"
                    >
                      <ShareNetworkIcon size={20} />
                      Manage Sharing
                    </Button>
                  </Col> */}
                    <Col sm="6">
                      <Button
                        variant="primary-100"
                        className="btn-md d-flex align-items-center justify-content-center gap-2 w-100"
                        onClick={() => {
                          setTranferReport(true);
                          setShowReportInfo(false);
                        }}
                      >
                        <ArrowsClockwiseIcon size={20} />
                        Transfer
                      </Button>
                    </Col>
                    <Col sm="6">
                      <Button
                        variant="danger-100"
                        className="btn-md d-flex align-items-center justify-content-center gap-2 w-100"
                        onClick={() => (setReportsToDelete([activeReport?.id]), setShowDeleteModal(true))}
                      >
                        <TrashIcon size={20} />
                        Delete
                      </Button>
                    </Col>
                  </Row>
                )}
              </div>
            </CardWrapper>
          </Col>
        )}
        {shareReport && (
          <Col md="3">
            <CardWrapper className="p-0 full-box-0">
              <div className="p-3 border-bottom border-grey-200 d-flex align-items-center justify-content-between gap-3">
                <h2 className="h5 fw-semibold mb-0">Share Report</h2>
                <button
                  type="button"
                  className="btn-reset"
                  onClick={() => {
                    setShowReportInfo(false);
                    // Only remove the class if we added it
                    if (sidebarCollapsedByReport) {
                      document.body.classList.remove("sidebar-collapsed");
                      setSidebarCollapsedByReport(false);
                    }
                  }}
                >
                  <Image src="/images/btn-close-square.svg" />
                </button>
              </div>
              <div className="report-info-body-2 p-3">
                <input
                  type="text"
                  id="search-contact"
                  aria-label="Search"
                  className="form-control form-control-search bg-gray-100 border-0 chat-search"
                  placeholder="Search here..."
                />
                <div className="chat-filter-tabs">
                  <button
                    type="button"
                    className={`chat-filter ${
                      shareReportByContact ? "active" : ""
                    }`}
                    onClick={() => {
                      setShareReportByContact(true);
                      setShareReportByEmail(false);
                      // setShareReportList({ userIDs: [] });
                      // setEmailInput("");
                    }}
                  >
                    Contacts
                  </button>
                  <button
                    type="button"
                    className={`chat-filter ${
                      shareReportByEmail ? "active" : ""
                    }`}
                    onClick={() => {
                      setShareReportByEmail(true);
                      setShareReportByContact(false);
                      // setShareReportList({ userIDs: [] });
                      // setEmailInput("");
                    }}
                  >
                    Email
                  </button>
                </div>

                {shareReportByContact && (
                  <ExpertAssignList
                    experts={expertUsers}
                    assignedExperts={shareReportList?.userIDs ?? []}
                    setFieldValue={setShareReportListHandle}
                    fieldName="userIDs"
                  />
                )}

                {shareReportByEmail && (
  <>
    {shareReportList.emails?.map((email, idx) => (
      <div className="d-flex align-items-center gap-2 position-relative mb-2" key={idx}>
        <Form.Control
          type="text"
          value={email}
          placeholder="Add user email here..."
          className="form-control"
          onChange={(e) => {
            const updatedEmails = [...shareReportList.emails];
            updatedEmails[idx] = e.target.value;
            setShareReportList(prev => ({ ...prev, emails: updatedEmails }));
            setShareReportListForApi(prev => ({ ...prev, emails: updatedEmails }));
          }}
        />
        <Button
          className="btn-reset"
          type="button"
          onClick={() => {
            const updatedEmails = [...shareReportList.emails];
            updatedEmails.splice(idx, 1);
            setShareReportList(prev => ({ ...prev, emails: updatedEmails }));
            setShareReportListForApi(prev => ({ ...prev, emails: updatedEmails }));
          }}
        >
          <Image
            src="/images/delete-red-rounded.svg"
            width={36}
            height={36}
            alt="Delete Icon"
          />
        </Button>
      </div>
    ))}

    <Button
      variant="dashed-primary"
      className="btn-md d-flex align-items-center justify-content-center gap-2 w-100 mt-3"
      onClick={() => {
        const updatedEmails = [...(shareReportList.emails || []), ""];
        setShareReportList(prev => ({ ...prev, emails: updatedEmails }));
      }}
    >
      <Image
        src="/images/plus-primary.svg"
        width={20}
        height={20}
        alt="Plus Blue Icon"
      />
      Add New Email
    </Button>
  </>
)}

              </div>
              <div className="border-top border-grey-200 d-flex align-items-center gap-2 p-3">
                <Button
                  variant="primary"
                  className="btn-md"
                  onClick={() => handleCallShareReportAPI()}
                >
                  Share Report
                </Button>
                <Button
                  variant="outline-secondary"
                  className="btn-md"
                  onClick={() => {
                    setShareReport(false);
                    setShowReportInfo(true);
                  }}
                >
                  Back
                </Button>
              </div>
            </CardWrapper>
          </Col>
        )}
        {tranferReport && (
          <Col md="3">
            <CardWrapper className="p-0 full-box-0">
              <div className="p-3 border-bottom border-grey-200 d-flex align-items-center justify-content-between gap-3">
                <h2 className="h5 fw-semibold mb-0">Transfer Report</h2>
                <button
                  type="button"
                  className="btn-reset"
                  onClick={() => {
                    setShowReportInfo(false);
                    // Only remove the class if we added it
                    if (sidebarCollapsedByReport) {
                      document.body.classList.remove("sidebar-collapsed");
                      setSidebarCollapsedByReport(false);
                    }
                  }}
                >
                  <Image src="/images/btn-close-square.svg" />
                </button>
              </div>
              <div className="report-info-body-2 p-3">
                {/* <input
                  type="text"
                  id="search-transfer-contact"
                  aria-label="Search"
                  className="form-control form-control-search bg-gray-100 border-0 chat-search"
                  placeholder="Search here..."
                /> */}

                <ExpertAssignList 
                experts={expertUsers}
                assignedExperts={transferReportListUser ?? []}
                setFieldValue={setTransferReportListUser}
                fieldName=""
                isRadio={true}
                />
              </div>
              <div className="border-top border-grey-200 d-flex align-items-center gap-2 p-3">
                <Button
                  variant="primary"
                  className="btn-md"
                  onClick={handleTransportReportAPI}
                >
                  Transfer Report
                </Button>
                <Button
                  variant="outline-secondary"
                  className="btn-md"
                  onClick={() => {
                    setTranferReport(false);
                  }}
                >
                  Back
                </Button>
              </div>
            </CardWrapper>
          </Col>
        )}
      </Row>

      {/* Share Report Modal */}
      <Modal
        className="info-modal"
        show={!!showShareReportModal}
        onHide={() => setShowShareReportModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-center">
            <Image src="/images/tick-badge-green.svg" alt="Check Badge" />
            <h2 className="fs-2 fw-semibold text-gray-700 mt-5 mb-2">
              Report Shared Successfully!
            </h2>
            <p className="fs-5 text-gray-500 fw-normal mb-0">
              Your report has been shared with the provided user emails.
            </p>

            <div className="d-flex align-items-center gap-3">
              <Button
                variant="primary"
                className="btn w-100 mt-5"
                onClick={() => setShowShareReportModal(false)}
              >
                Okay, Understood
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Share Report Modal */}
      <Modal
        className="info-modal"
        show={!!transferReportModal}
        onHide={() => setTransferReportModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-center">
            <Image src="/images/tick-badge-green.svg" alt="Check Badge" />
            <h2 className="fs-2 fw-semibold text-gray-700 mt-5 mb-2">
              Transfer Successful!
            </h2>
            <p className="fs-5 text-gray-500 fw-normal mb-0">
              Your report ownership has been transferred to the selected user.
            </p>

            <div className="d-flex align-items-center gap-3">
              <Button
                variant="primary"
                className="btn w-100 mt-5"
                onClick={() => {
                  setTransferReportModal(false);
                  setTranferReport(false);
                  setShowReportInfo(true);
                }}
              >
                Okay, Understood
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Delete Modal */}
      <Modal
        className="info-modal"
        show={!!showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-center">
            <Image src="/images/delete-badge-red.svg" alt="Delete Badge" />
            <h2 className="fs-2 fw-semibold text-gray-700 mt-5 mb-2">
              Are you sure you want to delete this report?
            </h2>

            <div className="d-flex align-items-center gap-3">
              <Button
                variant="primary"
                className="btn w-100 mt-5"
                onClick={() => {
                  // setShowDeleteModal(false);
                  deleteSelected(reportsToDelete)
                  setShowReportInfo(false);
                  // Only remove the class if we added it
                  if (sidebarCollapsedByReport) {
                    document.body.classList.remove("sidebar-collapsed");
                    setSidebarCollapsedByReport(false);
                  }
                }}
              >
                Yes, Delete Report
              </Button>
              <Button
                variant="gray"
                className="btn w-100 mt-5"
                onClick={() => setShowDeleteModal(false)}
              >
                No, Not Yet
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Opt Out Modal */}
      <Modal
        className="info-modal"
        show={!!showOptOutModal}
        onHide={() => setShowOptOutModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-center">
            <Image src="/images/delete-badge-red.svg" alt="Delete Badge" />
            <h2 className="fs-2 fw-semibold text-gray-700 mt-5 mb-2">
              Are you sure you want to opt-out from this report?
            </h2>

            <div className="d-flex align-items-center gap-3">
              <Button variant="primary" className="btn w-100 mt-5">
                Yes, Please
              </Button>
              <Button
                variant="gray"
                className="btn w-100 mt-5"
                onClick={() => setShowOptOutModal(false)}
              >
                No, Not Yet
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Quick Preview Modal */}
      <Modal
        className="quick-preview-modal preview-modal"
        show={!!showPreviewModal}
        onHide={() => (setReportToPreview(null), setShowPreviewModal(false))}
        centered
        size="xl"
      >
        {/* <Modal.Header
          className="d-flex align-items-center justify-content-between gap-4 px-4 py-3 border-0 rounded-4"
          closeButton
        >
          <Modal.Title className="fs-20 fw-semibold text-gray-700">
            {reportToPreview?.name}
          </Modal.Title>
          <Button
            variant="primary"
            className="btn-md d-flex align-items-center gap-2"
          >
            <EditIcon />
            Edit Template
          </Button>
        </Modal.Header> */}
        <Modal.Body className="p-0">
          <ReportPreview data={reportToPreview} />
        </Modal.Body>
      </Modal>
      {/* Quick Preview Modal */}
    </>
  );
};

export default ReportHubExpert;
